module.exports = __webpack_public_path__ + "JP.png?b3266baee2667e9f97f85532a3d828ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/JP.png
// module id = 367
// module chunks = 0